import React from 'react'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { ENewFilterRangeDesktop } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'

const MileageMin = withFilterContext(FilterName.min_mileage, SearchFiltersDropdown, {
    title: ENewFilterRangeDesktop.MIN,
    ariaLabel: ariaLabel.mileage.min,
})

const MileageMax = withFilterContext(FilterName.max_mileage, SearchFiltersDropdown, {
    title: ENewFilterRangeDesktop.MAX,
    ariaLabel: ariaLabel.mileage.max,
})

export const MileageMinAndMax = withFacetContext(FacetName.mileage, () => (
    <>
        <MileageMin title={ENewFilterRangeDesktop.MIN} />
        <MileageMax title={ENewFilterRangeDesktop.MAX} />
    </>
))
